import { msg } from "@lingui/core/macro";
import ky from "ky";
import { useRef, useState } from "react";
import useSWR from "swr";

import { usePoke } from "~/hook/domain/usePoke.ts";

export const EMOJI_DICT_URL = "/asset/emoji.json";
export const MESSAGE_LENGTH = 5;

export const BOOKMARK = [
  { depth: 0, icon: "😀", title: msg`스마일리 및 사람` },
  { depth: 6916, icon: "🐵", title: msg`동물 및 자연` },
  { depth: 8892, icon: "🍇", title: msg`음식 및 음료` },
  { depth: 10608, icon: "🌍", title: msg`여행 및 장소` },
  { depth: 13468, icon: "🎃", title: msg`활동` },
  { depth: 14560, icon: "👓", title: msg`사물` },
  { depth: 17940, icon: "🏧", title: msg`기호` },
  { depth: 20852, icon: "🏁", title: msg`깃발` },
];

export const usePokeWithEmoji = (email: string, close: () => void) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { isMutating, trigger } = usePoke();

  const [input, setInput] = useState<string[]>([]);
  const focusIndex = input.length;

  const [bookmarkPage, setBookmarkPage] = useState(0);

  const { data } = useSWR(EMOJI_DICT_URL, (key) =>
    ky.get(key).json<string[]>(),
  );

  const handleSelectEmoji = (emoji: string) => {
    setInput((p) => [...p, emoji].slice(-MESSAGE_LENGTH));
  };

  const handleRemoveEmoji = (index: number) => {
    setInput((p) => p.slice(0, index));
  };

  const handleSelectBookmark = (index: number, depth: number) => {
    setBookmarkPage(index);
    containerRef.current?.scroll({ left: depth + 12 });
  };

  const handleScroll = () => {
    const scrollLeft = containerRef.current?.scrollLeft ?? 0;
    const index = BOOKMARK.findLastIndex(({ depth }) => depth < scrollLeft);
    setBookmarkPage(index);
  };

  const handleSend = () => {
    void trigger({
      email,
      payload: { message: input.join(""), type: "emoji" },
    }).then(close);
  };

  return {
    bookmarkPage,
    containerRef,
    data,
    disabled: input.length !== MESSAGE_LENGTH || isMutating,
    focusIndex,
    handleRemoveEmoji,
    handleScroll,
    handleSelectBookmark,
    handleSelectEmoji,
    handleSend,
    input,
  };
};
